/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @date 2019-02-04 01:00 p.m
 * @description An Implentation for a React Componenet to fallback if The Application ran into errors
 * @filename error-boundary.tsx
 */
import React from "react";
const LOGO = require("../static/rv_logo_01.png");
const MOBILE_LOGO = require("../static/rv-logo-small.png");

/**
 * The state of the ErrorBoundary Component
 *
 * @interface
 */
interface ErrorBoundaryState {
  /**
   * The state of the Application
   *
   * @type {boolean}
   */
  hasError: boolean;
  /**
   * The URL of the tag-line.
   *
   * @type {string}
   */
  taglineUrl: string;
}

/**
 * A React component that renders the Share Button.
 *
 * @export
 * @class ErrorBoundary
 * @extends {React.Component<any,ErrorBoundaryState>}
 */
export class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false,
      taglineUrl: `${process.env.URL_MEDIA_IMAGE}/0a/us/0aUSTIfTQZu456apuXFTbw.svg`,
    };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      // render any custom fallback UI
      const windowSize = window.innerWidth;
      return (
        <div className="error-msg">
          <div className="main-navbar navbar navbar-expand-md navbar-dark fixed-top ">
            <a className="navbar-brand nav-logo" href="/">
              <img
                src={windowSize > 1500 ? LOGO : MOBILE_LOGO}
                alt="Radivision Error logo"
                className="logo d-inline-block"
              />
              <h5>Entrepreneurship unveiled.</h5>
            </a>
          </div>
          <div className="error-msg-content">
            <div className="dashed-shadow dashed-shadow-text">
              <span className="shadow">Oops!</span>
            </div>
            <p>
              Something went wrong!!
              <span>
                <a href="/#support:contact-us" target="_blank">
                  Contact technical support
                </a>
              </span>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
